module.exports = __webpack_public_path__ + "media/images/social-fb-04df504c19eb6f55aed982c010ba1d2e.png";